module.exports = __webpack_public_path__ + "static/media/907ty@4x.dd040cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/907ty@4x.png
// module id = 427
// module chunks = 0 1